import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareName } from '../../fragments/generated/ShareName';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareNameMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateShareNameMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, name: string } | { __typename?: 'CollectionShare', id: string, name: string } | null } | null };


export const UpdateShareName = /*#__PURE__*/ gql`
    mutation UpdateShareName($shareId: ID!, $name: String) {
  updateShare(input: {name: $name, shareId: $shareId}) {
    share {
      ...ShareName
    }
  }
}
    ${ShareName}` as unknown as DocumentNode<UpdateShareNameMutation, UpdateShareNameMutationVariables>;

          

          export const useUpdateShareNameMutation = (options?:MutationHookOptions<UpdateShareNameMutation, UpdateShareNameMutationVariables>) => useMutation(UpdateShareName, options);
          

          export type UpdateShareNameMutationOptions = MutationHookOptions<UpdateShareNameMutation, UpdateShareNameMutationVariables>;

          

          export type UpdateShareNameMutationResult = ReturnType<typeof useUpdateShareNameMutation>[1];

          
